export namespace WizardStepNotificationsTag {
    export type TagEnum = 'SIGNER' | 'WATCHER' | 'MANAGER' | '';
    export const TagEnum = {
        ALL: '' as TagEnum,
        SIGNER: 'SIGNER' as TagEnum,
        WATCHER: 'WATCHER' as TagEnum,
        MANAGER: 'MANAGER' as TagEnum
    };
}
